import { render, staticRenderFns } from "./LinkBtn.vue?vue&type=template&id=6a514bb9"
import script from "./LinkBtn.vue?vue&type=script&lang=js"
export * from "./LinkBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports